// extracted by mini-css-extract-plugin
export default {"headingContainer":"Heading_headingContainer__0ZkVW"};